import { BuiltCampaignControllerTriggerShare } from "../BuiltCampaignControllerTriggerShare";
import { BuiltCampaignControllerTriggerGeneric } from "../BuiltCampaignControllerTriggerGeneric";
import { BuiltCampaignControllerTriggerEvent } from "../BuiltCampaignControllerTriggerEvent";
import { BuiltCampaignControllerTriggerHasPriorReward } from "../BuiltCampaignControllerTriggerHasPriorReward";
import { BuiltCampaignControllerTriggerLegacyQuality } from "../BuiltCampaignControllerTriggerLegacyQuality";
import { BuiltCampaignControllerTriggerScore } from "../BuiltCampaignControllerTriggerScore";
import { BuiltCampaignControllerTriggerZoneState } from "../BuiltCampaignControllerTriggerZoneState";
import { BuiltCampaignControllerTriggerExpression } from "../BuiltCampaignControllerTriggerExpression";
import { BuiltCampaignControllerTriggerAudienceMembership } from "../BuiltCampaignControllerTriggerAudienceMembership";
import { BuiltCampaignControllerTriggerAccess } from "../BuiltCampaignControllerTriggerAccess";
import { BuiltCampaignControllerTriggerHasPriorStep } from "../BuiltCampaignControllerTriggerHasPriorStep";
import { BuiltCampaignControllerTriggerDataIntelligenceEvent } from "../BuiltCampaignControllerTriggerDataIntelligenceEvent";
import { BuiltCampaignControllerTriggerMaxMind } from "../BuiltCampaignControllerTriggerMaxMind";
import { BuiltCampaignControllerTriggerReferredByEvent } from "../BuiltCampaignControllerTriggerReferredByEvent";
import { BuiltCampaignControllerTriggerGroup } from "../BuiltCampaignControllerTriggerGroup";
const isBuiltCampaignControllerTriggerShareResponse = (response) => response.trigger_type === "SHARE";
const isBuiltCampaignControllerTriggerEventResponse = (response) => response.trigger_type === "EVENT";
const isBuiltCampaignControllerTriggerScoreResponse = (response) => response.trigger_type === "SCORE";
const isBuiltCampaignControllerTriggerZoneStateResponse = (response) => response.trigger_type === "ZONE_STATE";
const isBuiltCampaignControllerTriggerLegacyQualityResponse = (response) => response.trigger_type === "LEGACY_QUALITY";
const isBuiltCampaignControllerTriggerExpressionResponse = (response) => response.trigger_type === "EXPRESSION";
const isBuiltCampaignControllerTriggerHasPriorRewardResponse = (response) => response.trigger_type === "HAS_PRIOR_REWARD";
const isBuiltCampaignControllerTriggerAudienceMembershipResponse = (response) => response.trigger_type === "AUDIENCE_MEMBERSHIP";
const isBuiltCampaignControllerTriggerAccessResponse = (response) => response.trigger_type === "ACCESS";
const isBuiltCampaignControllerTriggerHasPriorStepResponse = (response) => response.trigger_type === "HAS_PRIOR_STEP";
const isBuiltCampaignControllerTriggerDataIntelligenceEventResponse = (response) => response.trigger_type === "DATA_INTELLIGENCE_EVENT";
const isBuiltCampaignControllerTriggerMaxMindResponse = (response) => response.trigger_type === "MAXMIND";
const isBuiltCampaignControllerTriggerReferredByEventResponse = (response) => response.trigger_type === "REFERRED_BY_EVENT";
const isBuiltCampaignControllerTriggerGroupResponse = (response) => {
    return response.trigger_type === "GROUP";
};
export const createBuiltCampaignControllerTriggers = (responses, context) => {
    const steps = [];
    responses.forEach((response) => {
        if (isBuiltCampaignControllerTriggerShareResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerShare(response, context));
        }
        else if (isBuiltCampaignControllerTriggerEventResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerEvent(response, context));
        }
        else if (isBuiltCampaignControllerTriggerScoreResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerScore(response, context));
        }
        else if (isBuiltCampaignControllerTriggerGroupResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerGroup(response, context));
        }
        else if (isBuiltCampaignControllerTriggerZoneStateResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerZoneState(response, context));
        }
        else if (isBuiltCampaignControllerTriggerLegacyQualityResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerLegacyQuality(response, context));
        }
        else if (isBuiltCampaignControllerTriggerExpressionResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerExpression(response, context));
        }
        else if (isBuiltCampaignControllerTriggerHasPriorRewardResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerHasPriorReward(response, context));
        }
        else if (isBuiltCampaignControllerTriggerAudienceMembershipResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerAudienceMembership(response, context));
        }
        else if (isBuiltCampaignControllerTriggerAccessResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerAccess(response, context));
        }
        else if (isBuiltCampaignControllerTriggerHasPriorStepResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerHasPriorStep(response, context));
        }
        else if (isBuiltCampaignControllerTriggerDataIntelligenceEventResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerDataIntelligenceEvent(response, context));
        }
        else if (isBuiltCampaignControllerTriggerMaxMindResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerMaxMind(response, context));
        }
        else if (isBuiltCampaignControllerTriggerReferredByEventResponse(response)) {
            steps.push(new BuiltCampaignControllerTriggerReferredByEvent(response, context));
        }
        else {
            steps.push(new BuiltCampaignControllerTriggerGeneric(response, context));
        }
    });
    return steps;
};
